import { Linking } from "react-native";

export const addUrlPrefixIfMissing = (url, prefix) => {
    prefix = prefix || 'https';
    // Check if the URL is null or undefined
    if (url === null || typeof url === 'undefined') {
        return '';
    }

    // Regular expression to check if "http://" or "https://" is not present at the beginning of the URL
    const httpRegex = /^(?!https?:\/\/)/;
    if (httpRegex.test(url)) {
        // If "http://" or "https://" is not present, check if "www." is already present
        if (!/^www\./.test(url)) {
            // If "www." is not present, add it to the beginning of the URL
            return `${prefix}://` + url;
        }
    }
    return url;
}

export function isValidUrlStrong(urlString) {
    const urlPattern = new RegExp("([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?");
    return !!urlPattern.test(urlString);
}

export const openExternalShortURL = async (shortUrl) => {
    try {
        // Fetch the headers of the short URL without actually opening it
        const shortUrlHeader = await fetch(shortUrl, { method: 'HEAD' });

        // Check if the response contains a 'location' header, which indicates a redirection
        const locationHeader = shortUrlHeader.headers.get('location');
        if (locationHeader) {
            // If the 'location' header is present, it means the short URL redirects to another URL.
            // You can try to open the redirected URL using Linking.openURL()
            await Linking.openURL(locationHeader);
        } else {
            // If there is no 'location' header, the short URL is the final destination URL,
            // and you can directly open it using Linking.openURL()
            await Linking.openURL(shortUrl);
        }
    } catch (error) {
        console.error('Error while opening URL: ', error);
    }
};

export const openExternalURL = async (url, prefix) => {
    prefix = prefix || 'https';
    try {
        const perfectUrl = addUrlPrefixIfMissing(url, prefix);
        const supported = await Linking.canOpenURL(perfectUrl);
        if (!supported) {
            console.error("Can't handle URL: " + perfectUrl);
        } else {
            await Linking.openURL(perfectUrl);
        }
    } catch (error) {
        console.error('Error while opening URL: ', error);
    }
};



